import styled from "styled-components";

const Footer = styled.footer`
  width: 100%;
  direction: rtl;
  background: #071525;
  color: #fff;
  padding: 0 20px;
  position: relative;
  overflow: hidden;

  /* פס עיצוב עליון */
  &::before {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 3px;
    background: linear-gradient(
      90deg,
      transparent,
      #3b82f6,
      #60a5fa,
      #3b82f6,
      transparent
    );
  }

  /* עיגול דקורטיבי */
  &::after {
    content: "";
    position: absolute;
    width: 300px;
    height: 300px;
    left: -180px;
    bottom: -200px;
    border-radius: 50%;
    border: 1px solid rgba(255, 255, 255, 0.05);
    pointer-events: none;
  }

  @media (max-width: 600px) {
    padding: 0 15px;
  }
`;

const FooterInner = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  padding: 55px 0 25px;

  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

const Brand = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const LogoLink = styled.a`
  display: inline-block;
  transition: transform 0.3s ease;
  position: relative;
  z-index: 2;

  &:hover {
    transform: translateY(-4px);
  }
`;

const Logo = styled.img`
  width: 280px;
  max-width: 75vw;
  height: auto;
  display: block;

  @media (max-width: 600px) {
    width: 220px;
  }
`;

const Tagline = styled.div`
  margin-top: 15px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.5);
  letter-spacing: 0.5px;
`;

const Line = styled.div`
  width: 100%;
  max-width: 850px;
  height: 1px;
  margin: 35px 0 22px;

  background: rgba(255, 255, 255, 0.09);
`;

const Copyright = styled.div`
  font-size: 14px;
  color: rgba(255, 255, 255, 0.65);
  line-height: 1.9;

  a {
    color: #60a5fa;
    text-decoration: none;
    font-weight: 700;
    transition: color 0.25s ease;
  }

  a:hover {
    color: #93c5fd;
  }

  @media (max-width: 600px) {
    font-size: 13px;
    max-width: 340px;
  }
`;

const Bottom = styled.div`
  margin-top: 12px;
  font-size: 11px;
  color: rgba(255, 255, 255, 0.28);
`;

export const Contact = () => {
  return (
    <Footer>
      <FooterInner>

        <Brand>

          <LogoLink
            href="https://siteb2b.co.il"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Site B2B"
          >
            <Logo
              src="/logooo1.png"
              alt="Site B2B"
            />
          </LogoLink>

          <Tagline>
            בניית אתרים • עיצוב • פיתוח
          </Tagline>

        </Brand>

        <Line />

        <Copyright>
          © {new Date().getFullYear()} כל הזכויות שמורות ל־
          <strong> SG1 ניהול ואחזקת מבנים </strong>
          {" "}–{" "}
          אתר זה נבנה על ידי{" "}
          <a
            href="https://siteb2b.co.il"
            target="_blank"
            rel="noopener noreferrer"
          >
            Site B2B
          </a>
        </Copyright>

        <Bottom>
          SG1 ניהול ואחזקת מבנים
        </Bottom>

      </FooterInner>
    </Footer>
  );
};
